export const BULK_UPLOAD_POLICIES = {
  BULK_UPLOAD: 'BulkUpload',
  BULK_UPLOAD_INITIAL_IMPORT: 'BulkUploadInitialImport'
} as const;

export type BulkUploadPermissionPolicy = (typeof BULK_UPLOAD_POLICIES)[keyof typeof BULK_UPLOAD_POLICIES];
